<template>
  <b-modal title="Itens da Entrada" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE ITENS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getEntradaItens" :fields="fields.entradaItem">
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="delItem(data.item)">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>

    <item-edit-modal ref="entradaItemEdit" @update="update()" />
    <confirm-modal ref="confirmEntradaItem" :descricao="'Deseja realmente remover o item ?'" @executar="executar()" />

    <template #modal-footer>
      <b-button class="pl-2 pr-3" variant="info" @click="adicionar()">
        <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
      </b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEntradaSaidaStore } from "@/stores/EntradaSaidaStore";
import TableFields from "@/tools/TableFields";
import Entrada from "@/models/Entrada";
import EntradaItem from "@/models/EntradaItem";
import EntradaItensEditModal from "@/components/modals/armazem/EntradaItensEditModal.vue";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal";

export default {
  name: "EntradaItensListModal",

  components: {
    "confirm-modal": ConfirmModal,
    "item-edit-modal": EntradaItensEditModal,
  },

  data() {
    return {
      show: false,
      fields: new TableFields(),
      entrada: new Entrada(0, "Nova Entrada", "", new Date(), "", "", "", ""),
      itens: [],
      item: new EntradaItem(0, "", "Novo Item", 0),
    };
  },

  methods: {
    editar(item) {
      item.entrada = this.entrada;
      this.$refs.entradaItemEdit.call(item);
    },

    adicionar() {
      let item = new EntradaItem(0, "", "Novo Item", 0);
      item.entrada = this.entrada;
      this.$refs.entradaItemEdit.call(item);
    },

    delItem(item) {
      this.item.update(item);
      this.$refs.confirmEntradaItem.call();
    },

    executar() {
      this.entradaSaidaStore.REMOVER_ENTRADA_ITEM(this.item.id).then(() => {
        this.update();
      });
    },

    update() {
      this.entradaSaidaStore.LISTAR_ENTRADA_ITENS(this.entrada.id).then(() => {
        this.item = new EntradaItem(0, "", "Novo Item", 0);
        this.itens = this.getEntradaItens;
      });
    },

    call(entrada) {
      this.show = !this.show;
      this.entrada = entrada;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const entradaSaidaStore = useEntradaSaidaStore();
    const { getEntradaItens } = storeToRefs(entradaSaidaStore);

    return {
      store,
      entradaSaidaStore,
      getEntradaItens,
    };
  },
};
</script>

<style lang="scss" scoped></style>
